import styled, { createGlobalStyle } from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';


const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background-color: #F4F4F4;
    background: linear-gradient(rgba(244,244,244,0.5), rgba(244,244,244,0.5)), url('img/assets/collage_bg_rotated_flat.png') center repeat;
    font-family: Inconsolata;
  }
`

const TopBorder = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: #f37c3e;
    z-index: 1000;
`;

const InvisibleLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
`;

const Header = styled.div.attrs({
  className: 'space-grotesk-regular'
})`
  text-align: left;
  padding: 20px 10px 20px 20px;
  color: #606060;
  font-size: 2em;
`

const PageHeader = styled.div`
    display: flex; /* Use flexbox for horizontal alignment */
    align-items: center; /* Vertically align items */
    color: #606060;
    padding-top: 10px;
    padding-left: 20px;
`;

const Logo = styled.img`
    width: 60px; /* Set the width of the image */
    height: auto; /* Maintain aspect ratio */
    margin-top: 10px;
`;

const NavChevron = styled.div`
    font-size: 24px; /* Adjust the font size as needed */
    ; /* Set the color of the chevron */
    margin: 0 10px; /* Add some spacing around the chevron */
`;

const SelectWrapper = styled.div`
    position: relative;
    display: inline-block;

    &::after {
        content: '▼'; /* Unicode character for the caret */
        color: #f37c3e; /* Adjust the color as needed */
        font-size: 10px;
        position: absolute;
        right: 10px; /* Adjust the position as needed */
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none; /* Prevent the caret from blocking clicks */
    }
`;

const StyledSelect = styled.select`
    font-family: 'Inconsolata';
    appearance: none;
    background: none;
    border: none;
    border-bottom: 3px solid #f37c3e;
    padding-right: 20px; /* Add some padding to make space for the custom caret */
    padding-bottom: 1px;
    cursor: pointer;
    font-size: 20px; /* Adjust the font size as needed */
    color: inherit; /* Inherit the text color */
    line-height: 1;

    /* Remove the default dropdown arrow */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    /* Position the select element relative to the custom caret */
    position: relative;
    display: inline-block;
`;


const Footer = styled.footer`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e0e0;
  padding: 12px 0;
  text-align: center;
  color: #606060;
`;


function Layout({ children }) {

  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const currentNavOption = path === '/' ? 'home' : path.replace('/', '');

  const onNavSelection = event => {
    const selectedPage = event.target.value;
    navigate(selectedPage === "home" ? "/" : `/${selectedPage}`);
  };

  return (
    <>
      <GlobalStyle/>
      <TopBorder />

      <PageHeader>
        <InvisibleLink href="/">
          <Logo src="img/assets/logo_large_grey_orange.png" alt="Basketology Logo" />
          <Header>basketology</Header>
        </InvisibleLink>
        <NavChevron>
          »
        </NavChevron>
        <SelectWrapper>
          <StyledSelect value={currentNavOption} onChange={onNavSelection}>
            <option value="home">Home</option>
            <option value="standings">Standings</option>
          </StyledSelect>
        </SelectWrapper>
      </PageHeader>

      {children}

      <Footer>
        © 2025 basketology. All rights reserved.
      </Footer>
    </>
  )
}

export default Layout;
